import { getCurrentIsAlphabetical } from "src/components/side-menu/side-menu-store";

export const registersSideMenuSearchEvent = (query: string) => {
  if (process.env.NODE_ENV !== `development`) {
    dataLayer.push({ event: "side-menu-search", inputValue: query })
  }
};

export const registerSideMenuNavigationEvent = (link: string) => {
  if (process.env.NODE_ENV !== `development`) {
    dataLayer.push({
      event: "side-menu-navigation",
      nextPageLink: link,
      sideMenuMode: getCurrentIsAlphabetical() ? 'A-Z' : 'Categories',
    })
  }
};
